const short = w => (w ? `${w.slice(0, 4)}…${w.slice(-4)}` : '');

// "paid" only once there is a transaction signature to show for it.
export function ledgerLabel(l) {
  if (l.kind === 'fee') return 'fees in';
  if (l.status === 'carried') return 'carried, joins your next win';
  return (l.status === 'sent' && l.sig ? 'paid ' : 'due ') + short(l.wallet);
}
